<template>
  <div class="marquee">
    <span :style="anim">
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'Marquee',
  props: {
    text: String,
  },
  computed: {
    anim() {
      return 'animation-duration:' + this.text.length / 3 + 's'
    }
  }
}
</script>


<style scoped>
.marquee {
  width: 100%;
  margin: 0 auto;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
}

.marquee span {
  display: inline-block;
  padding-left: 100%;
  animation-name: marquee;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  /* show the marquee just outside the paragraph */
}

/* Make it move */

@keyframes marquee {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(-100%, 0);
  }
}
</style>